import { ArrowDropDown } from '@mui/icons-material'
import { Button, Menu, MenuItem, Typography, styled } from '@mui/material'
import { TooltipCC } from 'components/common'
import { NS_TRANS } from 'constants/common'
import { useMenuCC } from 'hooks'
import { Fragment, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import theme, { color } from 'theme'
import { generateContrastColor } from 'utils/functions'

const MenuItemCC = styled(MenuItem)(({ theme }) => ({
    color: theme.palette.text.primary,
    fontWeight: 500,
    '&:hover': {
        backgroundColor: color.greyIL07,
        color: theme.palette.primary.main
    },
    '&:hover p': {
        color: theme.palette.primary.main
    }
}))

const LanguageCC = ({ useContrast }) => {

    const { t, i18n } = useTranslation([NS_TRANS.COMMON])
    const { open, anchorEl, setAnchorEl } = useMenuCC()
    const [currentLang, setCurrentLang] = useState(() => {
        return i18n.language
    })
    const handleChangeLang = (lang) => {
        i18n.changeLanguage(lang)
        setCurrentLang(lang)
        setAnchorEl(null)
        localStorage.setItem('lang', lang)
    }

    useEffect(() => {
        setCurrentLang(i18n.language)
        localStorage.setItem('lang', i18n.language)
    }, [i18n.language])
    

    return (
        <Fragment>
            <TooltipCC title={t('lang.changeLang')}>
                <Button
                    variant='text'
                    id="lang-more"
                    aria-controls={open ? 'lang-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                    sx={{ color: theme => useContrast ? generateContrastColor(theme.palette.primary.main) : theme.palette.primary.main, margin: { xs: `0 8px`, sm: `0 ${theme.spacing(4)}`}, fontWeight: '700'}}
                    endIcon={<ArrowDropDown sx={{ color: theme => useContrast ? generateContrastColor(theme.palette.primary.main) : theme.palette.primary.main }} />}
                >
                    {currentLang === 'vi' ? 'VIE' : 'ENG'}
                </Button>
            </TooltipCC>
            <Menu
                id="lang-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                MenuListProps={{
                    'aria-labelledby': 'lang-more',
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <TooltipCC placement="left" title={t('lang.vi')} >
                    <MenuItemCC key={'vie'} sx={{backgroundColor: currentLang === "vi" && color.backgroundColorChose}} onClick={() => handleChangeLang('vi')}>
                        <Typography sx={{ fontWeight: 700, marginRight: theme.spacing(1)}}>VIE </Typography> {t('lang.vi')}
                    </MenuItemCC>
                </TooltipCC>
                <TooltipCC placement="left" title={t('lang.en')}>
                    <MenuItemCC key={'eng'} sx={{backgroundColor: currentLang === "en" && color.backgroundColorChose}} onClick={() => handleChangeLang('en')}><Typography sx={{ fontWeight: 700, marginRight: theme.spacing(1) }}>ENG </Typography> {t('lang.en')}</MenuItemCC>
                </TooltipCC>
            </Menu>
        </Fragment>
    )
}

export default LanguageCC